declare global {
  interface Window {
    _env_?: {
      REACT_APP_BASE_URL?: string;
      REACT_APP_BIB_URL?: string;
      REACT_APP_SHOW_CREDIT_LABEL?: string;
      REACT_APP_QUEUE_NOTICE_ENABLED?: string;
      REACT_APP_QUEUE_NOTICE_DAYS?: string;
      REACT_APP_QUEUE_NOTICE_LIBRARY_NAME?: string;
      REACT_APP_FOOTER_LINK_ENABLED?: string;
      REACT_APP_FOOTER_LINK_URL?: string;
      REACT_APP_FOOTER_LINK2_ENABLED?: string;
      REACT_APP_FOOTER_LINK2_URL?: string;
    };
  }
}

const get = (key: keyof NonNullable<Window["_env_"]>): string | undefined =>
  window._env_?.[key] || process.env[key];

export const BASE_URL = get("REACT_APP_BASE_URL");
export const BIB_URL = get("REACT_APP_BIB_URL");
// Show the "Tegoed" text label instead of the wallet icon when set to "true".
export const SHOW_CREDIT_LABEL = get("REACT_APP_SHOW_CREDIT_LABEL") === "true";
// Show the upload-confirmation notice in the "my queue" window when set to "true".
export const QUEUE_NOTICE_ENABLED = get("REACT_APP_QUEUE_NOTICE_ENABLED") === "true";
// Number of days shown in that notice ("within the next X days"). Falls back to 2.
export const QUEUE_NOTICE_DAYS = Number(get("REACT_APP_QUEUE_NOTICE_DAYS")) || 2;
// Name of the library shown in that notice.
export const QUEUE_NOTICE_LIBRARY_NAME = get("REACT_APP_QUEUE_NOTICE_LIBRARY_NAME") || "";
// Optional links in the footer.
export const FOOTER_LINK_ENABLED = get("REACT_APP_FOOTER_LINK_ENABLED") === "true";
export const FOOTER_LINK_URL = get("REACT_APP_FOOTER_LINK_URL") || "";
export const FOOTER_LINK2_ENABLED = get("REACT_APP_FOOTER_LINK2_ENABLED") === "true";
export const FOOTER_LINK2_URL = get("REACT_APP_FOOTER_LINK2_URL") || "";
